import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { useI18n } from "@/i18n/i18n";
import { DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator } from "@/components/ui/dropdown-menu";
import { BrandAvatar } from "@/components/BrandAvatar";
import { Check, LogIn, Loader2 } from "lucide-react";
import { toast } from "sonner";

/** Las otras cuentas de la misma persona (admin / profe / estudiante). */
export const AccountSwitcher = () => {
  const { t } = useI18n();
  const [accounts, setAccounts] = useState([]);
  const [saltando, setSaltando] = useState("");

  useEffect(() => {
    api.get("/auth/linked-accounts")
      .then((r) => setAccounts(r.data?.accounts || []))
      .catch(() => setAccounts([]));
  }, []);

  if (accounts.length < 2) return null;

  const saltar = async (a) => {
    if (a.current || saltando) return;
    if (a.needs_login) { toast.error(t("sw_needs_login")); return; }
    setSaltando(a.user_id);
    try {
      await api.post("/auth/switch-account", { user_id: a.user_id });
      window.location.assign("/dashboard");   // recarga permisos y menú del perfil nuevo
    } catch (e) {
      toast.error(e?.response?.data?.detail || t("error_generic"));
      setSaltando("");
    }
  };

  return (
    <>
      <DropdownMenuSeparator />
      <DropdownMenuLabel className="text-[10.5px] uppercase tracking-wider text-slate-400 font-bold">
        {t("sw_title")}
      </DropdownMenuLabel>
      {accounts.map((a) => (
        <DropdownMenuItem
          key={a.user_id}
          disabled={!!saltando}
          onSelect={(e) => { e.preventDefault(); saltar(a); }}
          className={`gap-2.5 ${a.current ? "bg-slate-50" : ""} ${a.needs_login ? "opacity-60" : ""}`}
          data-testid={`switch-account-${a.user_id}`}
        >
          <BrandAvatar src={a.picture} alt={a.name} className="h-7 w-7 shrink-0" />
          <span className="flex flex-col min-w-0 flex-1 leading-tight">
            <span className="text-[13px] font-semibold truncate">{t(a.role)}</span>
            <span className="text-[10.5px] text-slate-500 truncate">{a.email}</span>
          </span>
          {saltando === a.user_id ? <Loader2 className="h-3.5 w-3.5 animate-spin shrink-0" />
            : a.current ? <Check className="h-3.5 w-3.5 text-emerald-600 shrink-0" />
            : a.needs_login ? <LogIn className="h-3.5 w-3.5 text-slate-400 shrink-0" title={t("sw_needs_login")} />
            : null}
        </DropdownMenuItem>
      ))}
    </>
  );
};

export default AccountSwitcher;
